import type { SepaPayment } from '@api/hooks/types/createTransaction';
import { ControlledTextInput } from '@components/ControlledTextInput';
import { Typography } from '@gurupay/gp-ui-library';
import { AddressGroupInput, BeneficiaryTypeInput } from '@pages/templates/components';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface AdditionalDataFormProps {
	formStatus: 'initial' | 'created' | 'warning';
}

export const AdditionalDataForm: FC<AdditionalDataFormProps> = ({ formStatus }) => {
	const { t } = useTranslation();

	return (
		<div className="space-y-space-40 my-space-16">
			<div className="space-y-space-16">
				<Typography level="h4">
					{t('payments.newPayment.additionalData.beneficiary')}
				</Typography>
				<ControlledTextInput
					disabled={formStatus === 'created'}
					label={t('payments.newPayment.additionalData.paymentNumber')}
					name="end_to_end"
					rules={{
						maxLength: {
							message: t('payments.common.maxLength', { maxLength: 35 }),
							value: 35,
						},
					}}
				/>
				<AddressGroupInput<SepaPayment>
					prefix="beneficiary.address"
					translatePrefix={'payments.newPayment.additionalData.address'}
					disabled={formStatus === 'created'}
					requiredIfSelection
				/>
				<BeneficiaryTypeInput<SepaPayment>
					prefix="beneficiary.id"
					translatePrefix="payments.newPayment.additionalData.beneficiaryInfo"
					disabled={formStatus === 'created'}
				/>
			</div>
			<div className="space-y-space-16">
				<Typography level={'h4'}>
					{t('payments.newPayment.additionalData.ultimateBeneficiary.title')}
				</Typography>
				<ControlledTextInput
					disabled={formStatus === 'created'}
					label={t('payments.newPayment.additionalData.ultimateBeneficiary.account')}
					name="ultimate_beneficiary.account"
				/>
				<ControlledTextInput
					disabled={formStatus === 'created'}
					label={t('payments.newPayment.additionalData.beneficiaryName')}
					name="ultimate_beneficiary.name"
					rules={{
						maxLength: {
							message: t('payments.common.maxLength', { maxLength: 70 }),
							value: 70,
						},
					}}
				/>

				<AddressGroupInput<SepaPayment>
					prefix="ultimate_beneficiary.address"
					translatePrefix="payments.newPayment.additionalData.ultimateBeneficiary.address"
					disabled={formStatus === 'created'}
					requiredIfSelection
				/>

				<BeneficiaryTypeInput<SepaPayment>
					prefix="ultimate_beneficiary.id"
					translatePrefix="payments.newPayment.additionalData.ultimateBeneficiary"
					disabled={formStatus === 'created'}
				/>
				<BeneficiaryTypeInput<SepaPayment>
					prefix="payer"
					translatePrefix="payments.newPayment.additionalData.payer"
					disabled={formStatus === 'created'}
				/>
				<BeneficiaryTypeInput<SepaPayment>
					prefix="primary_payer.id"
					translatePrefix="payments.newPayment.additionalData.ultimatePayer"
					disabled={formStatus === 'created'}
				/>
			</div>
		</div>
	);
};
